import { createContext, useMemo } from 'react';
import type { ReactNode } from 'react';

export const PlayerProfileContext = createContext<{
  imageUrl: string;
  name: string;
  secondaryHeader?: string;
  subheader?: string;
}>({
  imageUrl: '',
  name: '',
  secondaryHeader: undefined,
  subheader: undefined
});

export interface PlayerProfileProps {
  children: ReactNode;
  className?: string;
  imageUrl?: string;
  name: string;
  secondaryHeader?: string;
  subheader?: string;
}

export const PlayerProfile = ({
  children,
  className = 'grid grid-cols-[4.25rem_1fr] items-center justify-center text-center',
  imageUrl = '',
  name,
  secondaryHeader = '',
  subheader = undefined
}: PlayerProfileProps) => {
  const context = useMemo(() => {
    return {
      imageUrl,
      name,
      secondaryHeader,
      subheader
    };
  }, [imageUrl, name, secondaryHeader, subheader]);

  return (
    <div className={className}>
      <PlayerProfileContext.Provider value={context}>
        {children}
      </PlayerProfileContext.Provider>
    </div>
  );
};
